import React from 'react'

import Heading from 'components/Heading/Heading'
import MarkdownContent from 'components/MarkdownContent/MarkdownContent'
import Paragraph from 'components/Paragraph/Paragraph'
import Wrapper from 'components/Wrapper/Wrapper'
import useRouter from 'hooks/useRouter'

import styles from './CollectionPageHeader.module.css'

type CollectionPageHeaderProps = {
  title: string
  description: string
  additionalText: string
  userInteracted: boolean
}

const CollectionPageHeader: React.FC<CollectionPageHeaderProps> = ({
  title,
  description,
  additionalText,
  userInteracted,
}) => {
  const router = useRouter()
  const { page } = router.query

  return (
    <Wrapper>
      <div className={styles.innerWrapper}>
        <Heading level="h3" color="light">
          <h1 data-cy="collection-title">{title}</h1>
        </Heading>
        {description && (userInteracted || !page) && (
          <Paragraph color="light" style={{ margin: 0 }}>
            <MarkdownContent source={description} />
          </Paragraph>
        )}
        {additionalText && (userInteracted || !page) && (
          <Paragraph color="light" style={{ margin: 0 }}>
            <MarkdownContent source={additionalText} />
          </Paragraph>
        )}
      </div>
    </Wrapper>
  )
}

export default CollectionPageHeader
